export default "__VITE_ASSET__DuzfBRv7__"